export const CountryCodes = {
  ZA: 'ZA',
  UK: 'GB',
  US: 'US',
}
